import React, { useState, useEffect, useMemo } from "react";
import '../style/personaldetailform.css';
import { InputField, InputFieldWithDate, SelectBox, ButtonComponent, DatePickerComponent, TimeDuration, PhoneNumberInput } from "../component/Common";
import { addressStatusArray, daysArray, gender, maritalStatusOptions, monthsArray, NameChangeStatus, NamePrefix, otherOptionsArray, previousAddressStatusArray, SelectDependants, visaTypeArray, votersRoll, yearsArray, yesNoArray } from "../constants/form_constatnts";
import countryList from 'react-select-country-list';
import { calculateYearsDurations } from "../utils/utils";
import { validateTwoDates } from "../utils/validate";
import { isValidPhoneNumber } from "react-phone-number-input";
import api from "../utils/api";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";

const PersonalDetails = ({ onNextPage }) => {
    const navigate = useNavigate();
    const nationalityOptions = useMemo(() => countryList().getData(), [])
    const [formData, setFormData] = useState({
        title: '',
        otherTitle: '',
        forename: '',
        surname: '',
        dateOfBirth: null,
        nameStatus: '',
        previousName: '',
        nameChangeDate: null,
        genderStatus: '',
        motherMaidenName: '',
        homePhone: '',
        mobilePhone: '',
        workPhone: '',
        email: '',
        maritalStatus: '',
        smokersStatus: '',
        alcohalStatus: '',
        nationality: '',
        residency: '',
        voterRollStatus: '',
        dependantsCount: '',
        dependants: [],
        visa: '',
        passportStatus: '',
        passportIssuingCountry: '',
        PassportIssueDate: null,
        PassportExpiryDate: null,
        currentAddress: '',
        addressStatus: '',
        currentAddressDuration: {
            years: '',
            months: '',
            days: ''
        },
        previousAddresses: []
    });

    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const applicationId = searchParams.get('applicationId');

    useEffect(() => {
        if (!isInitialLoad) {
            if (applicationId) {
                fetchPersonalData(applicationId);
            }
        }
    }, [isInitialLoad]);

    const fetchPersonalData = async (id) => {
        try {
            const result = await api.get(`/get-personal-details/${id}`);
            var data = result.data.personalData;
            if (data) {
                setFormData((prevData) => ({
                    ...prevData,
                    title: NamePrefix.find(option => option.value === data.title) || '',
                    otherTitle: otherOptionsArray.find(option => option.value === data.otherTitle) || '',
                    forename: data.foreName || '',
                    surname: data.surname || '',
                    dateOfBirth: data.dateOfBirth || '',
                    nameStatus: NameChangeStatus.find(option => option.value === data.nameStatus) || '',
                    previousName: data.previousName || '',
                    nameChangeDate: data.nameChangeDate || '',
                    genderStatus: gender.find(option => option.value === data.gender) || '',
                    motherMaidenName: data.motherMaidenName || '',
                    homePhone: data.homePhone || '',
                    mobilePhone: data.mobilePhone || '',
                    workPhone: data.workPhone || '',
                    email: data.email || '',
                    maritalStatus: maritalStatusOptions.find(option => option.value === data.maritalStatus) || '',
                    smokersStatus: yesNoArray.find(option => option.value === data.smokerStatus) || '',
                    alcohalStatus: yesNoArray.find(option => option.value === data.alcoholStatus) || '',
                    nationality: nationalityOptions.find(option => option.label === data.nationality) || '',
                    residency: data.residency || '',
                    voterRollStatus: votersRoll.find(option => option.value === data.voterRollStatus) || '',
                    dependantsCount: SelectDependants.find(option => option.value === data.dependantsCount) || '',
                    dependants: data.dependantsData,
                    visa: visaTypeArray.find(option => option.value === data.visa) || '',
                    passportStatus: yesNoArray.find(option => option.value === data.passport) || '',
                    passportIssuingCountry: nationalityOptions.find(option => option.label === data.passportIssuingCountry) || '',
                    PassportIssueDate: data.passportIssueDate || null,
                    PassportExpiryDate: data.passportExpiryDate || null,
                    currentAddress: data.currentAddress || '',
                    addressStatus: addressStatusArray.find(option => option.value === data.addressStatus) || '',
                    currentAddressDuration: {
                        years: yearsArray.find(option => option.value === `${data.years}`) || '',
                        months: monthsArray.find(option => option.value === `${data.months}`) || '',
                        days: daysArray.find(option => option.value === `${data.days}`) || '',
                    },
                    previousAddresses: data.previousAddressData.map(row => ({
                        id: row.id,
                        address: row.address,
                        addressStatus: addressStatusArray.find(option => option.value === row.addressStatus) || '',
                        duration: {
                            years: yearsArray.find(option => option.value === `${data.years}`) || '',
                            months: monthsArray.find(option => option.value === `${data.months}`) || '',
                            days: daysArray.find(option => option.value === `${data.days}`) || '',
                        }
                    })),
                }))
            }
        } catch (error) {
            console.log("error of personal details", error);
        }
    }

    //handle error message
    useEffect(() => {
        for (const key in errors) {
            const errorMessageElement = document.getElementById(`error-message-${key}`);
            const dateErrorMessageElement = document.getElementById(`date-error-message-${key}`);
            const input = document.getElementById(`${key}`);
            if (errorMessageElement) {
                errorMessageElement.textContent = errors[key];
                if (input && (input.tagName.toLowerCase() === 'input')) {
                    if (errorMessageElement.textContent === '') {
                        input.style.setProperty('border', '1px solid #ccc', 'important');
                        input.style.setProperty('border-radius', '4px', 'important');
                    } else {
                        input.style.setProperty('border', '1px solid red', 'important');
                        input.style.setProperty('border-radius', '4px', 'important');
                    }
                }
            }
            if (dateErrorMessageElement) {
                dateErrorMessageElement.textContent = errors[key];
                if (input) {
                    const wrapper = input.getElementsByClassName('react-date-picker__wrapper')[0];
                    if (wrapper) {
                        if (dateErrorMessageElement.textContent === '') {
                            wrapper.style.setProperty('border', '1px solid gray', 'important');
                        } else {
                            wrapper.style.setProperty('border', '1px solid red', 'important');
                        }
                    }
                }
            }
        }
    }, [errors]);

    //handle current address duration change
    useEffect(() => {
        if (formData.currentAddressDuration.years && formData.currentAddressDuration.months && formData.currentAddressDuration.days) {
            setErrors((prevData) => ({ ...prevData, currentAddressDuration: "" }));
            setErrors((prevData) => ({ ...prevData, years: "" }));
            setErrors((prevData) => ({ ...prevData, months: "" }));
            setErrors((prevData) => ({ ...prevData, days: "" }));
        }
        if (formData.currentAddressDuration.years.value < 3) {
            if (formData.previousAddresses.length == 0) {
                setFormData((prevData) => ({
                    ...prevData,
                    previousAddresses: [{
                        address: '',
                        addressStatus: '',
                        duration: {
                            years: '',
                            months: '',
                            days: ''
                        }
                    }]
                }));
            }
        } else {
            setFormData((prevData) => ({
                ...prevData,
                previousAddresses: []
            }));
        }
    }, [formData.currentAddressDuration])

    //handle previous address duration change
    useEffect(() => {
        formData.previousAddresses.forEach((address, index) => {
            if (address.duration.years && address.duration.months && address.duration.days) {
                setErrors((prevData) => ({ ...prevData, [`previousAddressDuration_${index}`]: "" }));
                setErrors((prevData) => ({ ...prevData, [`years_${index}`]: "" }));
                setErrors((prevData) => ({ ...prevData, [`months_${index}`]: "" }));
                setErrors((prevData) => ({ ...prevData, [`days_${index}`]: "" }));
            }
        });
    }, [formData.previousAddresses])

    function getOrdinal(num) {
        const suffixes = ["th", "st", "nd", "rd"];
        const value = num % 100;
        return num + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0]);
    }

    // Handle change for text inputs
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [id]: value }));
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[id];
            return newErrors;
        });
    };

    // Handle change for select inputs
    const handleSelectChange = (value, name) => {
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevData) => ({ ...prevData, [name]: "" }));
    };

    // Handle date change
    const handleDateChange = (date, name) => {
        setFormData((prevData) => ({ ...prevData, [name]: date }));
        var result = validateTwoDates(date, name)
        setErrors((prevData) => ({ ...prevData, [name]: result }));
    };

    //handle phone number
    const handlePhoneNumber = (value, name) => {
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevData) => ({ ...prevData, [name]: "" }));
    }

    const handleGoBack = () => {
        navigate('/mortgage_dashboard');
    };

    // Handle form submission
    const handleFormSubmission = async () => {
        var isValid = true;
        const newErrors = {};
        let firstErrorFieldId = null;
        const setFieldError = (field, fieldName, errorMsg) => {
            if (!field) {
                isValid = false;
                newErrors[fieldName] = errorMsg;
                if (!firstErrorFieldId) firstErrorFieldId = fieldName;
            }
        };

        const setPhoneFieldError = (field, fieldName, errorMsg) => {
            if (!isValidPhoneNumber(field)) {
                isValid = false;
                newErrors[fieldName] = errorMsg;
                if (!firstErrorFieldId) firstErrorFieldId = fieldName;
            }
        };

        // Validate required fields
        setFieldError(formData.title, "title", "Please select title.");
        if (formData.title.value === 'Other') {
            setFieldError(formData.otherTitle, "otherTitle", "Other title is required.");
        }
        setFieldError(formData.forename, "forename", "Forename is required.");
        setFieldError(formData.surname, "surname", "Surname is required.");
        setFieldError(formData.dateOfBirth, "dateOfBirth", "Date of Birth is required.");

        if (formData.dateOfBirth) {
            const result = validateTwoDates(formData.dateOfBirth, 'dateOfBirth');
            if (result) {
                isValid = false;
                newErrors.dateOfBirth = result;
                if (!firstErrorFieldId) firstErrorFieldId = 'dateOfBirth';
            }
        }

        setFieldError(formData.nameStatus, "nameStatus", "Please select name change status.");
        if (formData.nameStatus.value === 'Yes') {
            setFieldError(formData.previousName, "previousName", "Previous name is required.");
            setFieldError(formData.nameChangeDate, "nameChangeDate", "Date of name change is required.");
            if (formData.nameChangeDate) {
                const result = validateTwoDates(formData.nameChangeDate, 'nameChangeDate');
                if (result) {
                    newErrors.nameChangeDate = result;
                    if (!firstErrorFieldId) firstErrorFieldId = 'nameChangeDate';
                }
            }
        }

        setFieldError(formData.genderStatus, "genderStatus", "Please select gender.");
        setFieldError(formData.motherMaidenName, "motherMaidenName", "Mother's maiden name is required.");
        setPhoneFieldError(formData.homePhone, "homePhone", "Enter valid home phone number.")
        setPhoneFieldError(formData.mobilePhone, "mobilePhone", "Enter valid phone number.")
        setPhoneFieldError(formData.workPhone, "workPhone", "Enter valid work phone number.")
        setFieldError(formData.email, "email", "Email address is required.");
        setFieldError(formData.maritalStatus, "maritalStatus", "Please select marital status.");
        setFieldError(formData.smokersStatus, "smokersStatus", "Please select smoking status.");
        setFieldError(formData.alcohalStatus, "alcohalStatus", "Please select alcohal status");
        setFieldError(formData.nationality, "nationality", "Please select a country.");
        if (formData.nationality.label && formData.nationality.label !== 'United Kingdom') {
            setFieldError(formData.visa, "visa", "Please select visa type.");
        }
        setFieldError(formData.residency, "residency", "Residency status is required.");
        setFieldError(formData.voterRollStatus, "voterRollStatus", "Please select an voter status.");
        setFieldError(formData.dependantsCount, "dependantsCount", "Please select number of dependants.")
        if (formData.dependantsCount.value > 0) {
            [...Array(parseInt(formData.dependantsCount.value))].forEach((dependant, index) => {
                setFieldError(formData.dependants[index]?.name || '', `dependantName_${index}`, "Dependant name is required.");
                setFieldError(formData.dependants[index]?.dateOfBirth || null, `dateOfBirth_${index}`, "Dependant date of birth is required.");
            });
        }
        setFieldError(formData.passportStatus, "passportStatus", "Please select passport status.");
        if (formData.passportStatus.value === 'Yes') {
            setFieldError(formData.passportIssuingCountry, "passportIssuingCountry", "Please select passport issuing country.");
            setFieldError(formData.PassportIssueDate, "PassportIssueDate", "Passport issue date is required.");
            setFieldError(formData.PassportExpiryDate, "PassportExpiryDate", "Passport expiry date is required.");
        }
        setFieldError(formData.currentAddress, "currentAddress", "Current address is required.");
        setFieldError(formData.addressStatus, "addressStatus", "Please select address status.");
        setFieldError(formData.currentAddressDuration.years, "years", "Please select address duration.");
        setFieldError(formData.currentAddressDuration.months, "months", "Please select address duration.");
        setFieldError(formData.currentAddressDuration.days, "days", "Please select address duration.");
        if (!formData.currentAddressDuration.years || !formData.currentAddressDuration.months || !formData.currentAddressDuration.days) {
            setFieldError(false, `currentAddressDuration`, "Please select address duration.");
        }

        // Validate previous addresses
        formData.previousAddresses.forEach((address, index) => {
            setFieldError(address.address, `previousAddress_${index}`, "Previous address is required.");
            setFieldError(address.addressStatus, `previousAddressStatus_${index}`, "Please select previous address status.");
            setFieldError(address.duration.years, `years_${index}`, "Please select address duration.");
            setFieldError(address.duration.months, `months_${index}`, "Please select address duration.");
            setFieldError(address.duration.days, `days_${index}`, "Please select address duration.");
            if (!address.duration.years || !address.duration.months || !address.duration.days) {
                setFieldError(false, `previousAddressDuration_${index}`, "Please select address duration.");
            }
        });

        // Set errors and scroll to the first field with error
        setErrors(newErrors);
        console.log('newErrors', newErrors);
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "") {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };

        if (isValid) {
            try {
                const result = await api.post(`/personal-details/${applicationId}`, formData);
                if (result.status == 200) {
                    Swal.fire({
                        icon: "success",
                        title: result.data.message,
                        iconColor: '#008000',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    onNextPage();
                }
            } catch (error) {
                console.log("post api error:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -220;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    };

    //save data when form is incomplete
    const saveFormData = async () => {
        var isValid = true;
        let firstErrorFieldId = null;
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "" && !element.innerText.includes('required')) {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };

        if (isValid) {
            try {
                const result = await api.post(`/personal-details/${applicationId}`, formData);
                if (result.status === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Your details have been saved successfully",
                        iconColor: '#008000',
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Exit ',
                        confirmButtonColor: '#0E2F4F',
                        cancelButtonText: 'Stay on Page',
                    }).then(async (response) => {
                        if (response.isConfirmed) {
                            navigate('/mortgage_dashboard');
                        } else if (response.isDismissed) {
                            window.location.reload();
                        }
                    });
                }
            } catch (error) {
                console.log("Post API error:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -220;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    };

    // handle address duration select
    const handleSelection = (value, name) => {
        setFormData((prevData) => ({
            ...prevData,
            currentAddressDuration: {
                ...prevData.currentAddressDuration,
                [name]: value
            }
        }));
    };

    //handle previous address details
    const handlePreviousAddressChange = (index, name, value) => {
        const updatedAddresses = [...formData.previousAddresses];
        updatedAddresses[index] = {
            ...updatedAddresses[index],
            [name]: value
        };
        setFormData({ ...formData, previousAddresses: updatedAddresses });
        if (name === 'address') {
            setErrors((prevData) => {
                const newErrors = { ...prevData };
                delete newErrors[`previousAddress_${index}`];
                return newErrors;
            });
        } else {
            setErrors((prevData) => ({ ...prevData, [`previousAddressStatus_${index}`]: "" }));
        }
    };

    // Custom styles for react-select to handle error borders
    const customSelectStyles = (fieldName) => ({
        control: (provided) => ({
            ...provided,
            borderColor: errors[fieldName] ? 'red' : provided.borderColor,
            '&:hover': {
                borderColor: errors[fieldName] ? 'red' : provided['&:hover'].borderColor,
            },
        }),
    });

    //handle previous address durations details
    const handlePreviousAddressDurationChange = (index, value, unit) => {
        const updatedAddresses = [...formData.previousAddresses];
        updatedAddresses[index] = {
            ...updatedAddresses[index],
            duration: {
                ...updatedAddresses[index].duration,
                [unit]: value
            }
        };
        setFormData({ ...formData, previousAddresses: updatedAddresses });
        const durationObj = updatedAddresses[index].duration;
        if (durationObj.years !== '' && durationObj.months !== '' && durationObj.days !== '') {
            var calculatedDurations = calculateYearsDurations(formData.currentAddressDuration, updatedAddresses);
            if (calculatedDurations !== null && calculatedDurations.years < 3 && calculatedDurations.isAddMore === true) {
                addPreviousAddress()
            } else {
                let cumulativeDuration = calculateYearsDurations(formData.currentAddressDuration, updatedAddresses.slice(0, index + 1));
                const filteredAddresses = updatedAddresses.filter((address, idx) => {
                    if (idx <= index) {
                        return true;
                    } else {
                        const durationToAdd = calculateYearsDurations(formData.currentAddressDuration, [address]);
                        cumulativeDuration.years += durationToAdd.years;
                        cumulativeDuration.months += durationToAdd.months;
                        cumulativeDuration.days += durationToAdd.days;
                        if (cumulativeDuration.days >= 30) {
                            cumulativeDuration.months += Math.floor(cumulativeDuration.days / 30);
                            cumulativeDuration.days = cumulativeDuration.days % 30;
                        }
                        if (cumulativeDuration.months >= 12) {
                            cumulativeDuration.years += Math.floor(cumulativeDuration.months / 12);
                            cumulativeDuration.months = cumulativeDuration.months % 12;
                        }
                        return cumulativeDuration.years < 3;
                    }
                });
                setFormData({ ...formData, previousAddresses: filteredAddresses });
            }
        }
    };

    const addPreviousAddress = () => {
        setFormData((prevData) => ({
            ...prevData,
            previousAddresses: [
                ...prevData.previousAddresses,
                {
                    address: '',
                    addressStatus: '',
                    duration: {
                        years: '',
                        months: '',
                        days: ''
                    }
                }
            ]
        }));
    };

    //form body
    const personaldetailform = () => {
        return (
            <div className="personal-details-form">
                <div className="form_name">Personal Details
                    <p>All fields are required to submit the application
                        <span className="required">*</span>
                    </p>
                </div>
                <SelectBox
                    label="Title"
                    options={NamePrefix}
                    htmlFor="title"
                    name="title"
                    value={formData.title}
                    placeholder='Select title'
                    onChange={(value) => handleSelectChange(value, 'title')}
                    styles={customSelectStyles('title')}
                />
                {formData.title.value === 'Other' &&
                    <SelectBox
                        label="Other Title"
                        placeholder='Please select a title'
                        options={otherOptionsArray}
                        htmlFor="otherTitle"
                        name="otherTitle"
                        value={formData.otherTitle}
                        onChange={(value) => handleSelectChange(value, 'otherTitle')}
                        styles={customSelectStyles('otherTitle')}
                    />
                }
                <InputField
                    label="Forename(s):"
                    htmlFor="forename"
                    type="text"
                    placeholder="Enter your forename(s)"
                    value={formData.forename}
                    onChange={handleInputChange}
                />
                <InputField
                    label="Surname:"
                    htmlFor="surname"
                    type="text"
                    placeholder="Enter your surname"
                    value={formData.surname}
                    onChange={handleInputChange}
                />
                <DatePickerComponent
                    label="Date of Birth"
                    htmlFor="dateOfBirth"
                    placeholder="Select your date of birth"
                    value={formData.dateOfBirth}
                    onChange={(date) => handleDateChange(date, 'dateOfBirth')}
                />
                <SelectBox
                    label="Have you ever changed your name ?"
                    options={NameChangeStatus}
                    htmlFor="nameStatus"
                    name="nameStatus"
                    value={formData.nameStatus}
                    placeholder="Select a value"
                    onChange={(value) => handleSelectChange(value, 'nameStatus')}
                    styles={customSelectStyles('nameStatus')}
                />
                {formData.nameStatus.value === 'Yes' && (
                    <InputFieldWithDate
                        label="Previous name(s) and dates of change:"
                        htmlFor1="previousName"
                        htmlFor2="nameChangeDate"
                        placeholder1="Enter previous name(s)"
                        type='text'
                        placeholder2="Select date of name change"
                        nameValue={formData.previousName}
                        dateValue={formData.nameChangeDate}
                        onChange={handleInputChange}
                        onDateChange={(date) => handleDateChange(date, 'nameChangeDate')}
                    />
                )}
                <SelectBox
                    label="Gender"
                    htmlFor="genderStatus"
                    placeholder="Select gender"
                    options={gender}
                    name="genderStatus"
                    value={formData.genderStatus}
                    onChange={(value) => handleSelectChange(value, 'genderStatus')}
                    styles={customSelectStyles('genderStatus')}
                />
                <InputField
                    label="Mother's Maiden Name:"
                    htmlFor="motherMaidenName"
                    type="text"
                    placeholder="Enter mother's maiden name"
                    value={formData.motherMaidenName}
                    onChange={handleInputChange}
                />
                <PhoneNumberInput
                    label="Home Telephone No:"
                    htmlFor="homePhone"
                    placeholder="Enter home telephone number"
                    value={formData.homePhone}
                    onChange={(value) => { handlePhoneNumber(value, 'homePhone') }}
                />
                <PhoneNumberInput
                    label="Mobile Telephone No:"
                    htmlFor="mobilePhone"
                    placeholder="Enter mobile number"
                    value={formData.mobilePhone}
                    onChange={(value) => { handlePhoneNumber(value, 'mobilePhone') }}
                />
                <PhoneNumberInput
                    label="Work Telephone No:"
                    htmlFor="workPhone"
                    placeholder="Enter work telephone number"
                    value={formData.workPhone}
                    onChange={(value) => { handlePhoneNumber(value, 'workPhone') }}
                />
                <InputField
                    label="Email Address:"
                    htmlFor="email"
                    placeholder="Enter email address"
                    value={formData.email}
                    onChange={handleInputChange}
                    type="email"
                />
                <SelectBox
                    label="Marital Status:"
                    htmlFor="maritalStatus"
                    options={maritalStatusOptions}
                    placeholder="Select marital status"
                    name="maritalStatus"
                    value={formData.maritalStatus}
                    onChange={(value) => handleSelectChange(value, 'maritalStatus')}
                    styles={customSelectStyles('maritalStatus')}
                />
                <SelectBox
                    label="Do you Smoke ?"
                    options={yesNoArray}
                    htmlFor='smokersStatus'
                    name="smokersStatus"
                    value={formData.smokersStatus}
                    onChange={(value) => handleSelectChange(value, 'smokersStatus')}
                    placeholder="Select an option"
                    styles={customSelectStyles('smokersStatus')}
                />
                <SelectBox
                    label="Do you Drink Alcohal ?"
                    options={yesNoArray}
                    htmlFor='alcohalStatus'
                    name="alcohalStatus"
                    value={formData.alcohalStatus}
                    onChange={(value) => handleSelectChange(value, 'alcohalStatus')}
                    placeholder="Select an option"
                    styles={customSelectStyles('alcohalStatus')}
                />
                <SelectBox
                    label="Nationality"
                    htmlFor="nationality"
                    placeholder='Select nationality'
                    options={nationalityOptions}
                    value={formData.nationality}
                    name="nationality"
                    onChange={(value) => handleSelectChange(value, 'nationality')}
                    styles={customSelectStyles('nationality')}
                />

                {formData.nationality.label && formData.nationality.label !== 'United Kingdom' && (
                    <SelectBox
                        label="Visa Type"
                        htmlFor="visa"
                        placeholder="Select visa type"
                        options={visaTypeArray}
                        name='visa'
                        value={formData.visa}
                        onChange={(value) => handleSelectChange(value, 'visa')}
                        styles={customSelectStyles('visa')}
                    />
                )}
                <InputField
                    label="Residency status in UK:"
                    htmlFor="residency"
                    placeholder="Enter residency status"
                    value={formData.residency}
                    onChange={handleInputChange}
                />
                <SelectBox
                    label="Currently on voters roll ?"
                    options={votersRoll}
                    htmlFor="voterRollStatus"
                    name="voterRollStatus"
                    value={formData.voterRollStatus}
                    placeholder="Select an option"
                    onChange={(value) => handleSelectChange(value, 'voterRollStatus')}
                    styles={customSelectStyles('voterRollStatus')}
                />
                <hr />
                <p className="formHeading">Dependants Details</p>
                <SelectBox
                    label="Select Number of Dependants:"
                    htmlFor="dependantsCount"
                    options={SelectDependants}
                    value={formData.dependantsCount}
                    placeholder="Select no. of dependants"
                    name="dependantsCount"
                    onChange={(value) => handleSelectChange(value, 'dependantsCount')}
                    styles={customSelectStyles('dependantsCount')}
                />
                {formData.dependantsCount && (
                    [...Array(parseInt(formData.dependantsCount.value))].map((_, i) => (
                        <InputFieldWithDate
                            key={i}
                            label={`Enter ${getOrdinal(i + 1)} dependant's Name and DOB :`}  // Use getOrdinal for label
                            htmlFor1={`dependantName_${i}`}
                            type='text'
                            htmlFor2={`dateOfBirth_${i}`}
                            placeholder1={`Enter name`}
                            nameValue={formData.dependants[i]?.name || ''}
                            dateValue={formData.dependants[i]?.dateOfBirth || null}
                            onChange={(e) => {
                                const updatedDependants = [...formData.dependants];
                                updatedDependants[i] = { ...updatedDependants[i], name: e.target.value };
                                setFormData((prevData) => ({ ...prevData, dependants: updatedDependants }));
                                setErrors((prevData) => {
                                    const newErrors = { ...prevData };
                                    delete newErrors[`dependantName_${i}`];
                                    return newErrors;
                                });
                            }}
                            onDateChange={(date) => {
                                const updatedDependants = [...formData.dependants];
                                updatedDependants[i] = { ...updatedDependants[i], dateOfBirth: date };
                                setFormData((prevData) => ({ ...prevData, dependants: updatedDependants }));
                                setErrors((prevData) => ({ ...prevData, [`dateOfBirth_${i}`]: '' }));
                            }}
                        />
                    ))
                )}
                <hr />
                <p className="formHeading">Passport Details</p>
                <SelectBox
                    label="Do you have Passport ?"
                    options={yesNoArray}
                    htmlFor='passportStatus'
                    name="passportStatus"
                    placeholder="Select an option"
                    value={formData.passportStatus}
                    onChange={(value) => handleSelectChange(value, 'passportStatus')}
                    styles={customSelectStyles('passportStatus')}
                />
                {formData.passportStatus.value === 'Yes' && (
                    <>
                        <SelectBox
                            label="Select Passport Issuing Country:"
                            htmlFor="passportIssuingCountry"
                            placeholder='Select passport issuing country'
                            options={nationalityOptions}
                            value={formData.passportIssuingCountry}
                            name="passportIssuingCountry"
                            onChange={(value) => handleSelectChange(value, 'passportIssuingCountry')}
                            styles={customSelectStyles('passportIssuingCountry')}
                        />
                        <DatePickerComponent
                            label="Passport Issue Date:"
                            htmlFor="PassportIssueDate"
                            placeholder="Select passport issue date"
                            value={formData.PassportIssueDate}
                            onChange={(date) => handleDateChange(date, 'PassportIssueDate')}
                        />
                        <DatePickerComponent
                            label="Passport Expiry Date:"
                            htmlFor="PassportExpiryDate"
                            placeholder="Select passport expiry date"
                            value={formData.PassportExpiryDate}
                            onChange={(date) => handleDateChange(date, 'PassportExpiryDate')}
                        />
                    </>
                )}
                <>
                    <hr />
                    <p className="formHeading">Current Details ( Minimum 3 years of address history is required )</p>
                    <InputField
                        label="Current address:"
                        htmlFor="currentAddress"
                        placeholder="Enter current address"
                        value={formData.currentAddress}
                        type="address"
                        onChange={handleInputChange}
                    />
                    <SelectBox
                        label="Status of current address:"
                        placeholder="Select status of current address"
                        options={addressStatusArray}
                        htmlFor="addressStatus"
                        name="addressStatus"
                        value={formData.addressStatus}
                        onChange={(value) => handleSelectChange(value, 'addressStatus')}
                        styles={customSelectStyles('addressStatus')}
                    />
                    <TimeDuration
                        label="Duration of stay at current address:"
                        htmlFor="currentAddressDuration"
                        fields={[
                            { name: 'years', value: formData.currentAddressDuration.years, options: yearsArray, style: customSelectStyles('years') },
                            { name: 'months', value: formData.currentAddressDuration.months, options: monthsArray, style: customSelectStyles('months') },
                            { name: 'days', value: formData.currentAddressDuration.days, options: daysArray, style: customSelectStyles('days') }
                        ]}
                        onChange={handleSelection}
                    />
                </>
                {formData.currentAddressDuration.days.value && parseInt(formData.currentAddressDuration.years.value) < 3 &&
                    formData.previousAddresses.map((address, index) => (
                        <div key={index} className="previous_add">
                            <hr />
                            <p className="formHeading">{index + 1}. Previous Details</p>
                            <InputField
                                label={`Previous Address:`}
                                htmlFor={`previousAddress_${index}`}
                                placeholder="Enter previous address"
                                value={address.address}
                                type="address"
                                onChange={(e) => handlePreviousAddressChange(index, 'address', e.target.value)}
                            />
                            <SelectBox
                                label="Status of previous address:"
                                htmlFor={`previousAddressStatus_${index}`}
                                placeholder="Select status of previous address"
                                options={previousAddressStatusArray}
                                name="previousAddressStatus"
                                value={address.addressStatus}
                                onChange={(value) => handlePreviousAddressChange(index, 'addressStatus', value)}
                                styles={customSelectStyles(`previousAddressStatus_${index}`)}
                            />
                            <TimeDuration
                                label="Duration of stay at previous address:"
                                htmlFor={`previousAddressDuration_${index}`}
                                fields={[
                                    { name: 'years', value: address.duration.years, options: yearsArray, style: customSelectStyles(`years_${index}`) },
                                    { name: 'months', value: address.duration.months, options: monthsArray, style: customSelectStyles(`months_${index}`) },
                                    { name: 'days', value: address.duration.days, options: daysArray, style: customSelectStyles(`days_${index}`) }
                                ]}
                                onChange={(value, unit) => handlePreviousAddressDurationChange(index, value, unit)}
                            />
                        </div>
                    ))
                }
                <div className="buttons-style">
                    <div className="back-btn"><ButtonComponent name="Back" onClick={handleGoBack} /></div>
                    <div className="button-div">
                        <ButtonComponent name='Save & Exit' onClick={saveFormData} />
                        <ButtonComponent label="Submit" name='Continue' onClick={handleFormSubmission} />
                    </div>
                </div>
            </div>
        );
    };
    return (
        <>
            {personaldetailform()}
        </>
    );
};

export default PersonalDetails;